import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type {
  PaginatedRequestResponse,
  Product,
  RequestResponse,
} from '@/types';

export interface ProductListParams {
  categoryId?: number;
  subcategoryId?: number;
}

export const fetchProducts = async (params: ProductListParams = {}) => {
  const response = await axiosInstance<PaginatedRequestResponse<Product[]>>(
    endpoints.products,
    {
      params: {
        ...(params.categoryId != null ? { categoryId: params.categoryId } : {}),
        ...(params.subcategoryId != null
          ? { subcategoryId: params.subcategoryId }
          : {}),
      },
    }
  );
  return response.data.data.data;
};

export const fetchProduct = async (id: number) => {
  const response = await axiosInstance<RequestResponse<Product>>(
    `${endpoints.products}/${id}`
  );
  return response.data.data;
};
